import './App.css';
import Navbar from './components/Navbar';
import Hero from './sections/Hero';
import About from './sections/About';
import Services from './sections/Services';
import Principles from './sections/Principles';
import Insights from './sections/Insights';
import Contact from './sections/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <div style={{ background: '#0D0D0D', minHeight: '100vh' }}>
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Principles />
      <Insights />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
